import { render, staticRenderFns } from "./OrderModal.vue?vue&type=template&id=4a7e4ac8&scoped=true"
import script from "./OrderModal.vue?vue&type=script&lang=ts"
export * from "./OrderModal.vue?vue&type=script&lang=ts"
import style0 from "./OrderModal.vue?vue&type=style&index=0&id=4a7e4ac8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a7e4ac8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Untitled/project/185/185admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a7e4ac8')) {
      api.createRecord('4a7e4ac8', component.options)
    } else {
      api.reload('4a7e4ac8', component.options)
    }
    module.hot.accept("./OrderModal.vue?vue&type=template&id=4a7e4ac8&scoped=true", function () {
      api.rerender('4a7e4ac8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/consignment/components/OrderModal.vue"
export default component.exports